export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-2-960-d5522048a3ce1377a73e392f60c51300.png";